import set from 'lodash/set';

import { CLIENT_CACHE_KEY } from '@web/constants';

/**
 * This util safely updates values in localStorage at the specified path
 * @param path to a value we want to update, i.e. reports.rangeMode
 * @param value we want to store
 */
export default function setInClientCache(path: string, value): void {
  // @TODO: make sure angular picks up localStorage changes made in React
  const clientCache = JSON.parse(localStorage.getItem(CLIENT_CACHE_KEY)) || {};
  set(clientCache, path, value);

  localStorage.setItem(CLIENT_CACHE_KEY, JSON.stringify(clientCache));
}
